<template>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="text-center"
        >
          <v-icon v-if="isMonitored" @click="emitStatus(false)" color="primary" x-large>mdi-account-eye</v-icon>
          <v-icon v-else @click="emitStatus(true)" color="grey lighten-1" x-large>mdi-account-eye-outline</v-icon>
        </div>
      </template>
      <span class="body-2">
        {{ $t(`host.label.${isMonitored ? 'unmonitor' : 'monitor'}`) }}
      </span>
    </v-tooltip>
  </template>
  
  <script>
  export default {
    name: 'HostMonitored',
  
    props: {
        monitored: { 
        type: Boolean,
        default: false,
      }
    },
  
    watch: {
        monitored(value) { 
        this.emitStatus(value)
      }
    },
  
    methods: {
      emitStatus(value) {
        this.$emit('setMonitored', value)
        this.isMonitored = value 
      }
    },
  
    data() {
      return {
        isMonitored: this.monitored,
      }
    }
  }
  </script>